module.exports = __webpack_public_path__ + "img/upload.12f402dc.png";